import React from "react"
import Avatar from "../../avatar"

const ImageCell = ({
  value,
  row: {
    original: { avatar_exists, first_name, last_name }
  }
}) => {
  return value ? (
    <Avatar avatarExists={avatar_exists} src={value} size="small" firstName={first_name} lastName={last_name} />
  ) : (
    ""
  )
}

export default ImageCell
